:host {
    display: flex;
    flex-direction: column;
    --ux-table-col-min-width: 150px;
    --ux-table-col-max-width: 500px;
    --cell-min-width: var(--ux-table-col-min-width);
    --cell-max-width: var(--ux-table-col-max-width);
}